class StarMegaMenuTabs extends HTMLElement {
  #abortController;
  #triggers = [];
  #panels = new Map();

  connectedCallback() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    this.#triggers = Array.from(this.querySelectorAll('[data-star-mega-menu-trigger]'));
    this.#panels = new Map();

    this.#triggers.forEach((trigger, index) => {
      const key = trigger.dataset.starMegaMenuTrigger;
      const panel = key ? this.querySelector(`[data-star-mega-menu-panel="${key}"]`) : null;

      if (panel instanceof HTMLElement) {
        this.#panels.set(trigger, panel);
      }

      trigger.addEventListener('pointerenter', () => this.#activate(index), {
        signal: this.#abortController.signal,
      });
      trigger.addEventListener('focus', () => this.#activate(index), {
        signal: this.#abortController.signal,
      });
      trigger.addEventListener('keydown', (event) => this.#handleKeydown(event, index), {
        signal: this.#abortController.signal,
      });
    });

    const initialIndex = this.#triggers.findIndex((trigger) => trigger.getAttribute('aria-expanded') === 'true');
    this.#activate(initialIndex >= 0 ? initialIndex : 0);
    this.dataset.enhanced = 'true';
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = undefined;
  }

  #activate(index) {
    if (index < 0 || index >= this.#triggers.length) return;

    this.#triggers.forEach((trigger, triggerIndex) => {
      const isActive = triggerIndex === index;
      const panel = this.#panels.get(trigger);

      trigger.setAttribute('aria-expanded', isActive.toString());

      if (panel) {
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', (!isActive).toString());
      }
    });
  }

  #handleKeydown(event, currentIndex) {
    let nextIndex;

    switch (event.key) {
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % this.#triggers.length;
        break;
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + this.#triggers.length) % this.#triggers.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.#triggers.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.#activate(nextIndex);
    this.#triggers[nextIndex]?.focus();
  }
}

if (!customElements.get('star-mega-menu-tabs')) {
  customElements.define('star-mega-menu-tabs', StarMegaMenuTabs);
}
